import React from 'react';
import { Position, Tooltip } from "@blueprintjs/core";

const CustomTooltip = ({ children, position = 'top', ...props }) => {
    let pos;

    switch(position) {
        default:
            pos = Position.TOP;
    }
    return (
        <Tooltip position={pos} {...props}>
            {children}
        </Tooltip>
    );
};

export default CustomTooltip;